/* eslint-disable jsx-a11y/anchor-is-valid */
import React,{useEffect, useState}from "react";
import { FaLongArrowAltUp ,FaLongArrowAltDown} from "react-icons/fa";
import { SwalWarn } from "../../../Popup";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../_helpers";
import { ImageExpandPopupCommon } from "../../tiles/ImageExpandPopupCommon";
import CertificateLink from "../../../CertificateLink";
import axios from "axios";
import { IVPCURRENCY } from "../../../../../env_config";
import getSymbolFromCurrency from "currency-symbol-map";
import DiamondTypeTag from "../../../Popup/DiamondTypeTag";
import ProfileComplete from "../../../Popup/ProfileComplete";

export const Tracklist = (props) => {
    const [swalWarnOpen,setSwalWarnOpen] = useState(false)
    const [alertMessage,setAlertMessage] = useState()
    const [profileModalOpen,setProfileModalOpen] = useState(false)
    const [currentCurrRate,setCurrentCurrRate] = useState("1")


    const HandleRestriction = () => {
        setProfileModalOpen(true)
    }
    function numberWithCommas(x) {
        if(!x){
            return "0.00"
        }
        return parseFloat(x).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    useEffect(() => {
        let curr = props.tracklistedcurrency ? ["cur", props.tracklistedcurrency.trim().toLowerCase()].join("_") : "cur_inr";
        
        axios({
            method: "POST",
            url: IVPCURRENCY,
            headers: { "Content-Type": "application/json" },
        }).then(response => {
            if(response && response.data){
                response.data.data[0].cur_usd = 1
                const currentCurrency = response.data.data[0][curr];
                setCurrentCurrRate(Math.round(currentCurrency*100)/100)
                // console.log(curr,currentCurrency)
            }
        })
    },[props.tracklistedcurrency,currentCurrRate])

    const getshortlistedsymbol = (responsecurrency) => {
        let symbol = getSymbolFromCurrency(responsecurrency)
        return symbol
      }

    return (
        <>
            <ProfileComplete profileModalOpen={profileModalOpen} setProfileModalOpen={setProfileModalOpen}/>
            {/* {props ? console.log("props", props) : null} */}
            <div className={`row border-bottom align-items-center position-relative ${props.stoneStatus !==1 ? "cursor-na" : ""}`}>
                {props.purchased?<span className="CanNotTracklist label label-outline-success label-pill label-inline bg-success-o-30 px-5">Purchased</span>:props.stoneStatus !== 1? <span className="CanNotTracklist label label-outline-danger label-pill label-inline bg-danger-o-30 px-5">Sold Out</span> :""}
                <div className={`col-md-8 mb-3 mt-2 ${props.stoneStatus !==1 ? "CanNotHoldDiv" : ""}`}>
                    <div className="d-flex">
                        <div className="text-center">
                        {props.image?<ImageExpandPopupCommon data={props}/>:<img
                                    className="img-fluid mr-2"
                                    alt={props.shape}
                                    src={toAbsoluteUrl(
                                        `/media/shape/${props.shape ? props.shape.toLowerCase() : ""}-no.png`
                                    )}
                                    width="50px"
                                    style={{ backgroundColor: "#f4f4f4" }}
                                />}
                        </div>
                        <div className="pl-2 p-0 text-left">
                            <div className={`mb-1 ${props.diamondType === "N" || props.diamondType === "W"  ? "natTab" : "labTab"} font-weight-bold`}>
                                <DiamondTypeTag diamondTypeTagColor={props.diamondTypeTagColor} diamondTypeTag={props.diamondTypeTag}/>
                                {/* {props.stoneStatus ===1 ? 
                                    <span onClick={() => history.push({ pathname: `/detail/${props.diamondType === "L"?"L":"N"}-${props.stockId}` })} className={`text-primary text-hover-primary cursor-pointer small ml-1`}>
                                        {props.diamondType === "N" || props.diamondType === "W" ? "N" : "L"}-{props.stockId}
                                    </span>
                                : 
                                    <span className={`text-primary small ml-1`}>
                                        {props.diamondType === "N" || props.diamondType === "W" ? "N" : "L"}-{props.stockId}
                                    </span>
                                } */}
                                {(!props.showprice) ? 
                                    <span className="text-primary small cursor-pointer" onClick={(e) => HandleRestriction()}>
                                        {props.diamondType === "N" || props.diamondType === "W"? "N" : "L"}-{props.stockId}
                                    </span>
                                : props.stoneStatus ===1 ?
                                    <a className="text-primary text-hover-primary small" href={`/detail/${props.diamondType === "L"?"L":"N"}-${props.stockId}?SearchId=0&searched_from=D_Tracklist`} target="_blank" rel="noreferrer" >
                                        {props.diamondType === "N" || props.diamondType === "W" ? "N" : "L"}-{props.stockId}
                                    </a> : 
                                    <span className="text-primary small">
                                        {props.diamondType === "N" || props.diamondType === "W" ? "N" : "L"}-{props.stockId}
                                    </span>
                                }
                                
                                <CertificateLink Certificate_link={props.certificate_link} lab={props.lab} certificate={props.certificate} className={`mx-2 text-primary small`}  displaycertificate={props?.showcertificate}/>
                            </div>

                            <span className="text-dark font-weight-bold d-block">
                                {props.shape}{" "}
                                {parseFloat(props.carat).toFixed(2)}{" "}
                                {props.color}
                                {props.clarity}{" "}{props.cut}{" "}{props.polish}{" "}{props.symmetry}{" "}
                                {props.fluorescence}
                            </span>
                        </div>
                    </div> 
                </div>
                {props.showprice &&
                <div className={`col-md-4 text-right d-flex justify-content-end  ${props.stoneStatus !==1 ? "CanNotHoldDiv" : ""}`}>
                    <div>
                        <div className="text-muted font-weight-bold">
                            {
                                props.stoneStatus === 1 ?
                                <>{props.tracklistedcurrencysymbol}/CT
                                        <span className="ml-1">{numberWithCommas(props.tracklistedcurrentprice/props.carat)}</span></>
                                :null
                            }
                        </div>
                        <div className="text-dark font-weight-bold">
                            { props.stoneStatus === 1 ?
                                props.conversionrate !== 1 ? 
                                    <>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip id="tooltip">
                                                    ${numberWithCommas(props.tracklistedcurrentprice)}
                                                </Tooltip>
                                            }
                                        >
                                            <span> { props.tracklistedcurrencysymbol}{numberWithCommas(props.tracklistedcurrentprice)}</span>
                                        </OverlayTrigger>
                                    </>
                                :
                                    <span> { props.tracklistedcurrencysymbol}{numberWithCommas(props.tracklistedcurrentprice)}</span>
                                : null
                            }
                        </div>
                    </div>
                    <div>
                        { 
                            !props.priceIndicator || props.stoneStatus !== 1 || props.purchased 
                            ? null
                            : props.priceIndicator === "Green"
                            ?
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Tooltip id="tooltip">
                                            Tracklisted Cost {props.tracklistedcurrencysymbol}/CT <b>{numberWithCommas(props.tracklistedprice/props.carat)} </b>
                                            <br/>Tracklisted Cost price<b> {props.tracklistedcurrencysymbol}{numberWithCommas(props.tracklistedprice)}</b> 
                                        </Tooltip>
                                    }
                                >
                                    <span><FaLongArrowAltDown className='text-success cursor-pointer font-size-h3' /></span>
                                </OverlayTrigger>
                            :
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Tooltip id="tooltip">
                                            Tracklisted Cost {props.tracklistedcurrencysymbol}/CT <b>{numberWithCommas(props.tracklistedprice/props.carat)} </b>
                                            <br/>Tracklisted Cost price<b> {props.tracklistedcurrencysymbol}{numberWithCommas(props.tracklistedprice)}</b> 
                                        </Tooltip>
                                    }
                                >
                                    <span><FaLongArrowAltUp className='text-danger cursor-pointer  font-size-h3' /></span>
                                </OverlayTrigger>
                        }
                    </div>
                    {/* <div className="text-danger font-weight-bold"><FaLongArrowAltUp /> {props.pricehike}</div> */}
                </div>}
            </div>
            <SwalWarn show={swalWarnOpen} message={alertMessage} onClose={() => setSwalWarnOpen(false)} /> 
        </>
    );
};
